import {
  getFirestore,
  doc,
  getDoc,
  updateDoc,
  arrayUnion,
  arrayRemove
} from "firebase/firestore";
import { app } from "../../credenciales";

const db = getFirestore(app);

export const getActivityDates = async (idActividad) => {
  try {
    const docRef = doc(db, "actividades", idActividad);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      if (Array.isArray(data.fechas)) {
        const fechasArray = data.fechas.map(item => item.fecha || "Fecha no disponible");
        return fechasArray;
      }
    } else {
      console.error("No se encontró el documento.");
    }
  } catch (error) {
    console.log(error);
  }
}

export const addDatesToActivity = async (newDateWithUsers, id) => {
  try {
    const docRef = doc(db, "actividades", id);
    await updateDoc(docRef, {
      fechas: arrayUnion(newDateWithUsers),
    });
  } catch (error) {
    console.log(error);
  }
}

export const deleteDateFromActivity = async (date, id) => {
  try {
    const docRef = doc(db, "actividades", id);
    await updateDoc(docRef, {
      fechas: arrayRemove(date)
    });
  } catch (error) {
    console.log(error);
  }
}